import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBurn } from '@fortawesome/free-solid-svg-icons'
import { SetUnbalanceBurnDialog, SecondaryCta } from 'components'
import React from 'react'

function GridUnbalanceBurn(row) {
  return (
    <div className="flex flex-row-reverse flex-nowrap justify-between items-center gap-4 w-full">
      <SetUnbalanceBurnDialog
        togglerComponent={SecondaryCta}
        togglerProps={{
          size: 'grid',
          className: 'min-w-[20em]',
        }}
        rowData={row}
      >
        <FontAwesomeIcon icon={faBurn} fixedWidth />
      </SetUnbalanceBurnDialog>
    </div>
  )
}
export const MemoizedGridUnBalanceBurn = React.memo(GridUnbalanceBurn)
